import md5 from 'md5';
import downloadImage from "../../../../../utils/downloadImage";
import fs from 'fs';

export const fetchAllUserImages = async () => {
  try {
    const imgAmount = 45;
    const relativeAvatarsPath = `/landings/assets/images/avatars/`;
    const avatarsFolderPath = `${process.cwd()}/public${relativeAvatarsPath}`;

    if (process.env.NODE_ENV === 'development') {
      const avatarsFolder = await fs.promises.readdir(avatarsFolderPath);
      if (avatarsFolder.length > imgAmount) {
        const filesToIgnore = ['.gitkeep', '.DS_Store'];
        return avatarsFolder
          .filter(f => !filesToIgnore.includes(f))
          .map(f => `${relativeAvatarsPath}${f}`);
      }
    }

    const response = await fetch("https://v3.verzel.com.br/api/user/avatars");
    const data = await response.json();
    const images = data.map((avatar) => avatar.avatar);

    const repeatedImages = [];
    while (repeatedImages.length < imgAmount) {
      repeatedImages.push(...images);
    }

    const shuffledImages = repeatedImages
      .slice(0, 45)
      .sort(() => Math.random() - 0.5);

    const downloadImgReqs = [];
    const avatarImages = [];

    for (const img of shuffledImages) {
      const imgExtensionRegex = /\/.*(\..*)\?AWSAccessKeyId/g;
      const regexResponse = imgExtensionRegex.exec(img);

      if (regexResponse?.length && regexResponse[1]) {
        const imgExtension = regexResponse[1];
        const imgHash = md5(img)
        const imgName = `${imgHash}${imgExtension}`;
        const relativeImgPath = `${relativeAvatarsPath}${imgName}`;
        const fullImgPath = `${process.cwd()}/public/${relativeImgPath}`;

        avatarImages.push(relativeImgPath);
        downloadImgReqs.push(downloadImage(img, fullImgPath));
      }
    }

    await Promise.all(downloadImgReqs);

    return avatarImages;
  } catch (error) {
    console.error("Error fetching user images:", error);
    return [];
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default () => null;